import { Country } from "../country";

export enum SerialNumberScope {
  Event = 'Event',
  Business = 'Business',
}

export function getSerialNumberScopeOfCountry(country: Country): SerialNumberScope {
  switch(country) {
    case Country.Austria:
      return SerialNumberScope.Event;
    case Country.Hungary:
      return SerialNumberScope.Event;
    case Country.Romania:
      return SerialNumberScope.Business;
    case Country.Slovakia:
      return SerialNumberScope.Event;
    case Country.Slovenia:
      return SerialNumberScope.Event;
  }
}
